import ReactDOM from "react-dom/client";
import React from 'react';
import App from "./App.jsx";
import "./style.css";

const entryPoint = document.getElementById("root");
ReactDOM.createRoot(entryPoint).render(<App/>);